export default "__VITE_ASSET__BHXQsfRV__"